<template>
  <div id="app" class="wrap-container">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>
